import ApiService from "@/services/api.service";
import SettingsService from "@/services/settings.service.js";
import json2xml from "json2xml";
/* eslint-disable */
const state = {};

const getters = {};

const actions = {
  getIssue({ commit }, options) {
    var settings = SettingsService.settings;
    const url =
      settings.RedmineURL +
      "issues/" +
      options.id +
      ".json?include=attachments,journals";
    return ApiService.getRedmine(url, options.key);
  },
  newIssue({ state }, options) {
    var settings = SettingsService.settings;
    const url = settings.RedmineURL + "issues.json";
    return ApiService.postRedmine(
      url,
      options.key,
      json2xml({issue: options.payload}, { header: true, attributes_key: "attr" })
        .replace("<uploads>", '<uploads type="array">')
        .replace("<custom_fields>", '<custom_fields type="array">')
    );
  },
  updateIssue({ commit }, options) {
    var settings = SettingsService.settings;
    const url = settings.RedmineURL + "issues/" + options.id + ".json";
    return ApiService.putRedmine(
      url,
      options.key,
      json2xml({issue: options.payload}, { header: true, attributes_key: "attr" })
        .replace("<uploads>", '<uploads type="array">')
        .replace("<custom_fields>", '<custom_fields type="array">')
    );
  },
  deleteIssue({ state }, options) {
    var settings = SettingsService.settings;
    const url = settings.RedmineURL + "issues/" + options.id + ".json";
    return ApiService.deleteRedmine(url, options.key);
  },

  getUsers({ commit }, options) {
    var settings = SettingsService.settings;
    const url =
      settings.RedmineURL +
      "projects/" +
      options.project +
      "/memberships.json?limit=100";
    return ApiService.getRedmine(url, options.key);
  },

  getTrackers({ commit }, options) {
    var settings = SettingsService.settings;
    const url = settings.RedmineURL + "trackers.json?limit=100";
    return ApiService.getRedmine(url, options.key);
  },

  getStatuses({ commit }, options) {
    var settings = SettingsService.settings;
    const url = settings.RedmineURL + "issue_statuses.json?limit=100";
    return ApiService.getRedmine(url, options.key);
  },

  uploadFile({ state }, options) {
    var settings = SettingsService.settings;
    const url =
      settings.RedmineURL + "uploads.json?filename=" + options.file.name;
    console.log(options);
    return ApiService.postFileRedmine(
      url,
      options.key,
      options.blob,
      "application/octet-stream"
    );
  },

  getCustomFields({ commit }, options) {
    var settings = SettingsService.settings;
    const url = settings.RedmineURL + "custom_fields.json?limit=100";
    return ApiService.getRedmine(url, options.key);
  },
};

const mutations = {};

export const redmine = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
